// Vastgoed data Kempenaar 29 — direct van Funda
export const property = {
  address: "Kempenaar 29",
  postalCode: "3961 KN",
  city: "Wijk bij Duurstede",
  neighborhood: "De Horden Schepen",
  price: "€ 739.000",
  priceSuffix: "k.k.",
  energyLabel: "A",
  pricePerM2: "€ 5.394",
  livingArea: "137",
  plotArea: "265",
  volume: "536",
  bedrooms: 4,
  bathrooms: 1,
  rooms: 5,
  yearBuilt: 1988,
  floors: 3,
  status: "Beschikbaar",
  acceptance: "In overleg",
  type: "Eengezinswoning · 2-onder-1-kapwoning",
  roof: "Zadeldak met pannen",
  fundaUrl: "https://www.funda.nl/detail/koop/wijk-bij-duurstede/huis-kempenaar-29/44486481/",
  coords: { lat: 51.9704724, lng: 5.3312634 },
  floorplanEmbed: "https://fmlpub.s3-eu-west-1.amazonaws.com/embed.html?designId=304173181&projectId=186540709",
  videoUrl: "https://www.funda.nl/detail/koop/wijk-bij-duurstede/huis-kempenaar-29/44486481/media/videos",
  videoThumb: "https://customer-vzk8jgcsaz84e8sb.cloudflarestream.com/1e0b89088e6a348f7d0291c56b9e6285/thumbnails/thumbnail.jpg?width=1280&height=720",
  tagline: "Een licht, instapklaar familiehuis met vrij uitzicht over het groen.",
  intro:
    "Vrij uitzicht over het groen, een zonnige tuin op het zuiden, vier slaapkamers én een royale woonkeuken. Deze uitstekend onderhouden twee-onder-één-kapwoning combineert ruimte, comfort en een fantastische ligging tot het ideale familiehuis.",
  story: [
    "In een groene en kindvriendelijke woonomgeving ligt deze ruime twee-onder-één-kapwoning met aangebouwde garage, extra berging, bijkeuken, royale woonkeuken en een heerlijke zonnige achtertuin op het zuiden.",
    "De woning geniet van een prachtige ligging met vrij uitzicht over een groenvoorziening en een groot grasveld aan de voorzijde. Met vier slaapkamers, volop leefruimte en diverse duurzame voorzieningen biedt deze woning alles wat een comfortabel gezinshuis compleet maakt.",
    "De huidige eigenaren hebben de woning met veel zorg onderhouden, gemoderniseerd en verduurzaamd. Hierdoor is een instapklaar woonhuis ontstaan waar u direct kunt genieten van jarenlang woonplezier."
  ],
  highlights: [
    { label: "Woonoppervlakte", value: "137 m²" },
    { label: "Perceel", value: "265 m²" },
    { label: "Slaapkamers", value: "4" },
    { label: "Energielabel", value: "A" }
  ],
  features: [
    { icon: "Sun", title: "Zonnepanelen", desc: "12 panelen geïnstalleerd in 2020" },
    { icon: "Flame", title: "Hybride warmtepomp", desc: "Nieuwe cv-ketel met spaarpomp (2024)" },
    { icon: "Wind", title: "Airconditioning", desc: "In de hoofdslaapkamer (2020)" },
    { icon: "Trees", title: "Tuin op het zuiden", desc: "81 m² zonnige achtertuin, 7,10 × 11,40 m" },
    { icon: "Home", title: "Aangebouwde garage", desc: "Met elektra, verwarming en isolatie" },
    { icon: "Layers", title: "Volledig geïsoleerd", desc: "Dak, muur, vloer & HR-dubbel glas" },
    { icon: "Sparkles", title: "Trappen gerenoveerd", desc: "Vernieuwd in 2023" },
    { icon: "Warehouse", title: "Extra berging", desc: "Gerealiseerd in 2023" },
    { icon: "MapPin", title: "Ideale ligging", desc: "Korte afstand tot binnenstad & scholen" }
  ],
  neighborhoodInfo: {
    name: "De Horden Schepen",
    city: "Wijk bij Duurstede",
    residents: "1.710",
    families: "35%",
    avgPrice: "€ 4.324",
    description:
      "Een groene, kindvriendelijke buurt aan de rand van de gezellige historische binnenstad van Wijk bij Duurstede. Wandel binnen enkele minuten naar winkels, scholen en sportvoorzieningen — of stap op de fiets richting de Lek."
  }
};

export const photos = [
  "https://cloud.funda.nl/valentina_media/230/008/690.jpg?options=width=2160", // hero / front
  "https://cloud.funda.nl/valentina_media/230/008/762.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/876.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/830.jpg?options=width=2160",
  "/images/photo5_netflix.jpg", // photo 5: Netflix on TV + popcorn animation
  "https://cloud.funda.nl/valentina_media/230/008/835.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/922.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/702.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/834.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/695.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/908.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/742.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/816.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/884.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/784.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/970.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/898.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/789.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/765.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/897.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/746.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/847.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/691.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/737.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/879.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/804.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/962.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/786.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/688.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/919.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/845.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/766.jpg?options=width=2160",
  "https://cloud.funda.nl/valentina_media/230/008/703.jpg?options=width=2160"
];

export const makelaar = {
  name: "Carole van den Bogerd",
  title: "Makelaar / Taxateur o.g.",
  phone: "06 22333667",
  phoneClean: "+31622333667",
  email: "info@carolevandenbogerd.nl",
  website: "https://www.carolevandenbogerd.nl/",
  fundaProfile: "https://www.funda.nl/makelaar/17432",
  contactUrl: "https://www.funda.nl/makelaar-contact/?listingId=8031028",
  viewingUrl: "https://www.funda.nl/makelaar-contact/?listingId=8031028&viewingRequest=true",
  address: "Galenus 4, 3962 MC Wijk bij Duurstede",
  hours: "Ma–Vr · 09:00–17:00",
  rating: "9,9",
  reviewCount: 7,
  certificates: ["VastgoedCert", "NWWI", "NRVT"],
  languages: ["Nederlands", "Engels"],
  portrait: "/images/carole.png",
  whatsappNumber: "31622333667",
  whatsappMessage: "Hoi Carole, ik heb interesse in de woning aan de Kempenaar 29 in Wijk bij Duurstede. Kunnen we contact hebben?"
};
